import type { ParticipantTypeMinimal } from '../lib/types';

/**
 * Returns the minimum price across all participant types when at least one is paid,
 * or null when every type is free (or no types are configured). Used by event cards
 * to render "De la X RON".
 */
export function priceFromForActivity(types: ParticipantTypeMinimal[] | undefined | null): number | null {
  if (!types || types.length === 0) return null;
  const numeric = types.map((t) => parseFloat(t.price) || 0);
  const anyPaid = numeric.some((p) => p > 0);
  if (!anyPaid) return null;
  return Math.min(...numeric);
}

export function formatPrice(value: number | string): string {
  const num = typeof value === 'string' ? parseFloat(value) : value;
  if (Number.isNaN(num) || num === 0) return 'Gratuit';
  if (Number.isInteger(num)) return `${num} RON`;
  return `${num.toFixed(2)} RON`;
}
